export default __webpack_public_path__ + "static/media/pay-process-icon.8fd82a39.svg";